const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "(Uitbetaald)",
  makeChoice: "Maak hier uw keuze.",
  seeAll: "Weergeven alles",
  clear: "Verwijderen",
  back: "Terug",
  save: "Opslaan",
  close: "Sluiten",
  of: "Van",
  to: "tot",
  copyrights: "© {date} Bridgestone Solutions. Alle rechten voorbehouden.",
  pageNotFound: "Pagina niet gevonden",
  accessDenied: "Toegang geweigerd",
  search: "Zoeken",
  year: "Jaar",
  buttons: {
    export: "Exporteren",
    delete: "Verwijderen",
    save: "Opslaan",
    cancel: "Annuleren",
    next: "Doorgaan",
    back: "TERUG",
    skip: "Overslaan",
    send: "Versturen",
    clear: "Verwijderen",
    readNow: "Lees nu",
    pointsList: "Puntenlijst",
    more: "Meer",
    close: "Sluiten",
    reportError: "Fout melden",
    accept: "Accepteren",
    download: "Downloaden",
    downloadAll: "Download alles",
    dealerInfoDownload: "Downloaden",
    toTheBasket: "Toevoegen aan winkelmand",
    toOrderDelivery: "Ga door naar het leveringsadres",
    discover: "Ontdekken",
    newAddress: "Nieuw leveringsadres aanmaken",
    selectAddressBtn: "Selecteer uw leveradres",
    toOrderSummary: "Naar uw bestellingsoverzicht",
    placeOrder: "Bestelling bevestigen",
    toDashboard: "Naar de startpagina",
    newOrder: "Nieuwe bestelling",
    userOrders: "Toegang tot uw bestellingen",
    toSearch: "Zoeken",
    select: "Kiezen",
    moreCustomerNumbers: "+ MEER KLANTNUMMERS TOEVOEGEN",
    loadMore: "Meer laden",
    loading: "Laden...",
    toStaffDashboard: "Naar dashboard",
    toQuiz: "Om te quizen",
    vouchers: "Waardebonnen",
    exchangeVoucher: "Vouchercode inwisselen",
    confirm: "Bevestigen",
    sharePoints: "Deel punten",
    downloadSelection: "Selectie downloaden",
    selectAll: "Alles selecteren",
    deselectAll: "Alles deselecteren",
    setFilters: "Gelieve <b>maximaal één filter</b> per kolom te selecteren",
    clearFilters: "Filter resetten",
    create: "Aanmaken",
    update: "Bijwerken",
    toBDrive: "TOEGANG TOT B-DRIVE",
    preview: "Voorbeeld",
    clickHere: "Details bekijken",
    all: "Alles",
  },
  tooltips: {
    info: "Hulp nodig? Contacteer plusbelux&commat;bridgestone.eu ",
  },
  confirmation: {
    header: "Bevestiging vereist",
    message: "Wilt u dit record verwijderen?",
  },
  nav: {
    consents: "Toestemmingen",
    dashboard: "Startpagina",
    accountDashboard: "Startpagina",
    account: "Mijn profiel",
    mailbox: "Postvak IN",
    singleMailbox: "Bericht",
    stammdaten: "Basisgegevens",
    news_feeds: "Nieuws",
    pointsOverview: "Puntenoverzicht",
    rewardsOverview: "Puntenoverzicht",
    about: "Over BS Plus",
    service_number: "Contactservice",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    salesPromotions: "Verkoopbevordering",
    shopCategory: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    productDetails: "Productgegevens",
    userOrders: "Gebruikersbestellingen",
    shoppingCart: "Winkelwagen",
    orderDelivery: "Verzendadres",
    orderSummary: "Bestellingsoverzicht",
    orderComplete: "Bestelling voltooid",
    text_page: "Statische pagina",
    staff: "Service-dashboard",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    training: "Training",
    trainingForm: "Trainingsformulier",
    staffVouchers: "Waardebonnen",
    wholesalerVouchers: "Waardebonnen",
    promotions: "Dashboard",
    brochure_prices: "Informatie Over Producten",
    investment: "Investeringssteun",
    media: "Mediakits & logo’s",
    medias: "Mediatheek",
    wholesaler: "Dashboard",
    contact_service: "Contact et Service",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    premium_partner_contact: "PREMIUM PARTNER ONDERSTEUNING",
    productInfo: "Informatie Over Producten",
    bDrive: "Productafbeeldingen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Voorwaarden voor deelname",
    first_stop: "Bridgestone bandengarantie",
    payouts: "Payouts",
  },
  breadcrumbs: {
    dashboard: "Startpagina",
    accountDashboard: "Startpagina",
    account: "Mijn profiel",
    mailbox: "Postvak IN",
    singleMailbox: "Bericht",
    stammdaten: "Basisgegevens",
    news_feeds: "Nieuws",
    pointsOverview: "Puntenoverzicht",
    rewardsOverview: "Puntenoverzicht",
    about: "Over BS Plus",
    service_number: "Contactservice",
    shop: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    salesPromotions: "Verkoopbevordering",
    shopCategory: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
    productDetails: "Productgegevens",
    userOrders: "Gebruikersbestellingen",
    shoppingCart: "Winkelwagen",
    orderDelivery: "Verzendadres",
    orderSummary: "Bestellingsoverzicht",
    orderComplete: "Bestelling voltooid",
    staff: "Service-dashboard",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    training: "Training",
    trainingForm: "Trainingsformulier",
    staffVouchers: "Waardebonnen",
    wholesalerVouchers: "Waardebonnen",
    promotions: "Dashboard",
    brochure_prices: "Informatie Over Producten",
    investment: "Investeringssteun",
    media: "Mediakits & logo’s",
    medias: "Mediatheek",
    wholesaler: "Dashboard",
    contact_service: "Contact et Service",
    dekouple_contact: "ASSISTANCE BOUTIQUE",
    bridgestone_contact: "ASSISTANCE BRIDGESTONE PLUS",
    premium_partner_contact: "PREMIUM PARTNER ONDERSTEUNING",
    productInfo: "Informatie Over Producten",
    bDrive: "Productafbeeldingen",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Voorwaarden voor deelname",
    first_stop: "Bridgestone bandengarantie",
    payouts: "Payouts",
  },
  menu: {
    account: "Mijn profiel",
    plus: 'Over Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Verkoopondersteuning",
    mailbox: "Postvak IN",
    about: "Over BS Plus",
    trainingAndCourses: "Trainingen en cursussen",
    externalTraining: "Externe trainingen",
    productInfo: "Productinformatie",
    productBrochures: "Productbrochures",
    priceLists: "Prijslijsten",
    price: "Pricat",
    complaintForm: "Klachtenformulier",
    sales_support: "Verkoopondersteuning",
    contact_service: "Contact & Service",
    logOut: "Uitloggen",
    news: "Nieuws",
    news_feeds: "Nieuws",
    service_number: "Contactservice",
    salesPromotions: "Verkoopbevorderende acties",
    shop: "BRIDGESTONE <span class='text-danger'>PLUS</span> shop",
    onlineTrainings: "Online trainingen",
    trainings: "Trainingen",
    brochure_prices: "INFORMATIE OVER PRODUCTEN",
    media: "Mediatheek",
    medias: "Mediatheek",
    stammdaten: "Basisgegevens",
    preislisten: "Prijslijsten",
  },
  validation: {
    requiredField: "Verplichte velden",
  },
  sortBy: {
    default: "Sorteren op",
    desc: "Sorteren op: Nieuwste",
    asc: "Sorteren op: Oudste",
    name: "Naam",
    date: "Datum",
    choiceBy: "Sorteren",
  },
  month: {
    1: "januari",
    2: "februari",
    3: "maart",
    4: "april",
    5: "mei",
    6: "juni",
    7: "juli",
    8: "augustus",
    9: "september",
    10: "oktober",
    11: "november",
    12: "december",
  },
};

export default {
  messages,
};
